import React from 'react';
import { FaTimes, FaPaperPlane, FaEye } from 'react-icons/fa';
import { getSchoolConfig } from '../../utils/domainConfig';
import '../../styles/WhatsAppPreviewModal.css';

const WhatsAppPreviewModal = ({ 
  show, 
  onClose, 
  onConfirm, 
  noticeDate, 
  noticeTitle, 
  noticeBody, 
  attachment,
  recipientCount 
}) => {
  if (!show) return null;
  const schoolConfig = getSchoolConfig();

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="np-overlay" onClick={onClose}>
      <div className="np-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="np-header">
          <div className="np-header-left">
            <FaEye className="np-header-icon" />
            <h2>Notice Preview</h2>
          </div>
          <button className="np-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Info bar */}
        <div className="np-info-bar">
          This notice will be sent to <strong>{recipientCount}</strong> recipient{recipientCount !== 1 ? 's' : ''}
        </div>

        {/* Preview body */}
        <div className="np-body">
          <div className="np-notice-card">
            {/* Attachment preview */}
            {attachment && (
              <div className="np-media">
                {attachment.type.startsWith('image/') ? (
                  <img src={attachment.preview} alt="Notice" className="np-media-img" />
                ) : (
                  <div className="np-doc-preview">
                    <span className="np-doc-icon">📄</span>
                    <div className="np-doc-info">
                      <span className="np-doc-name">{attachment.name}</span>
                      <span className="np-doc-size">{(attachment.size / 1024).toFixed(1)} KB</span>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Notice content */}
            <div className="np-notice-content">
              {!attachment && (
                <div className="np-notice-header"><strong>Notice</strong></div>
              )}
              <div className="np-date">Date: <strong>{formatDate(noticeDate)}</strong></div>

              <div className="np-greeting">Dear Parents/Guardians,</div>
              <div className="np-title-line">
                This is to inform you about <strong>{noticeTitle}</strong>.
              </div>

              <div className="np-body-text">{noticeBody}</div>

              <div className="np-footer-text">
                <div>For any queries, please contact the school office between <strong>8AM &amp; 3PM</strong>.</div>
                <div>Thank you,</div>
                <div className="np-school-name"><strong>{schoolConfig.schoolName}.</strong></div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer actions */}
        <div className="np-footer">
          <button className="np-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="np-confirm-btn" onClick={onConfirm}>
            <FaPaperPlane />
            Send to {recipientCount} Recipient{recipientCount !== 1 ? 's' : ''}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppPreviewModal;
